<template>
    <D3Stores></D3Stores>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../Layouts/AuthLayout.vue")
);
const D3Stores = defineAsyncComponent(() =>
    import("../../components/Finance/D3Stores/D3Stores.vue")
);

export default {
    name: "d3_stores_page", //The name you are in should not equal the name of the component you are importing.
    components: { D3Stores, AuthLayout },
};
</script>
